import { createReducer } from '@reduxjs/toolkit' ;
import { getapproveonboardingbusinessInfoRequest, getapproveonboardingbusinessInfoSuccess, getapproveonboardingbusinessInfoFailure } from '../../actions/adminFlow/approvebusinessInfoAction';

const initialState = {
  businessInfoLoading: false,
  businessInfoSuccess:'',
  businessInfoError:'',
  businessInforesponseData: null,

};


const approvebusinessInfoReducer = createReducer(initialState, (builder) => {
	
	builder
		.addCase(getapproveonboardingbusinessInfoRequest, (state) => { 
			state.businessInfoLoading = true;
			state.businessInforesponseData = true;
		}).addCase(getapproveonboardingbusinessInfoSuccess, (state, action) => {
			state.businessInfoLoading = false;
			state.businessInfoSuccess = action.payload.data;
		}).addCase(getapproveonboardingbusinessInfoFailure, (state, action) => {
			state.businessInfoLoading = false;
			state.businessInfoError = action.payload;
		}).addDefaultCase(() => { });
});

export default approvebusinessInfoReducer;
	